var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('NavBar'),_c('Hero'),_c('Services'),_c('Products'),_c('Product'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }